import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
// Images
import Card from "@mui/material/Card";
import { useEffect, useState } from "react";
import MDButton from "../../../../components/MDButton";
import DataTableDataUsers from "./data";
import Modal from '@mui/material/Modal';
import InsertUserComponent from "../../users/insert";
import { useNavigate } from "react-router-dom";
import { DialogShower, SnackShower, TableShower } from "../../../../components/Utils/Tools";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { modalStyle } from "../../../../components/Utils/ModalStyle";
import { TextField, Tooltip } from "@mui/material";
import LoadingOverlay from 'react-loading-overlay';
import UserService from "../../../../services/user.service";
import { Label, LabelImportant } from "@mui/icons-material";
import { Image } from "react-bootstrap";
import MDAvatar from "../../../../components/MDAvatar";
import CoreService from "../../../../services/core.service";
import FormField from "../../account/components/FormField";
import Autocomplete from "@mui/material/Autocomplete";
import clientsService from "../../../../services/clients.service";
import { getUserRole } from "../../../../services/auth.service";
import MDEditor from "../../../../components/MDEditor";
import UnitCreateModal from "../../../../components/UnitCreateModal";

const filterUnitOptions = (options, { inputValue }) => {
    const search = inputValue.trim().toLowerCase();
    const matches = options.filter((option) => unitLabel(option).toLowerCase().includes(search));
    if (/^\d+$/.test(search)) {
        const exists = options.some((option) => String(option.unit || "").trim() === search);
        matches.push({ id: "add-unit", unit: exists ? `Add unit "${search}" on another floor` : `Add unit "${search}"`, newUnitNumber: search });
    }
    return matches;
};
const unitLabel = (option) => option?.newUnitNumber
    ? option.unit
    : option?.unit ? `${option.unit} — Floor ${option.floor || "?"}, Section ${option.section || "?"}` : "";


function Users() {


    const title = "New User"
    const defaultInputValues = { newPassword: '', passwordConfirmation: '' }
    const [values, setValues] = useState(defaultInputValues);
    const [isValid, setIsValid] = useState(false);
    const validationSchema = Yup.object().shape({
        newPassword: Yup.string()
            .required('New Password is required')
            .min(6, 'New Password must be at least 6 characters'),
        passwordConfirmation: Yup.string()
            .oneOf([Yup.ref('newPassword'), null], 'Passwords must match'),
    });
    const { register, handleSubmit, formState: { errors } } =
        useForm({ mode: "all", resolver: yupResolver(validationSchema) });

    const [activeLoading, setActiveLoading] = useState(false);
    const [showModalChangePassword, setShowModalChangePassword] = useState(false);
    const [showModalUserInfo, setShowModalUserInfo] = useState(false);
    const [showModalChangeUnit, setShowModalChangeUnit] = useState(false);
    const [selectedUser, setSelectedUser] = useState({});
    const [snackBarSetting, setSnackBarSetting] = useState({ type: "error", error_message: "", show: false });
    const [selectedRecipients, setSelectedRecipients] = useState({});
    const [showBulkEmailModal, setShowBulkEmailModal] = useState(false);
    const [bulkEmailSubject, setBulkEmailSubject] = useState("");
    const [bulkEmailBody, setBulkEmailBody] = useState("");

    const [userInsertSetting, setUserInsertSetting] = useState({
        show: false, showBulk: true,
        title: "Main Building"
    });
    const handleChange = (value) => {
        setValues(value);
        setIsValid(validationSchema.isValidSync(values));
    };
    setTimeout(function () {
        setIsValid(validationSchema.isValidSync(values));
    }, 1000);

    const onClickSaveData = (e) => {
        console.log("onClickSaveData");

        e.preventDefault();
        if (isValid) {
            setActiveLoading(true);
            values["user"] = selectedUser.id
            UserService.ChangePasswordAdminMode(values)
                .then((e) => {
                    setSnackBarSetting({ ...snackBarSetting, show: true, type: "info", error_message: "" })
                    window.location.reload(true);
                    setActiveLoading(false);
                }).catch((err) => {
                    setSnackBarSetting({ ...snackBarSetting, show: true, type: "error", error_message: err.response.data.status })
                    setActiveLoading(false);
                });
        }

    }


    const onClickSaveDataUnits = (e) => {
        console.log("onClickSaveDataUnits");

        e.preventDefault();
        if (!selectedBuildingItem?.id || !selectedUnitItem?.id) {
            setSnackBarSetting({ type: "error", error_message: "Select a building and an existing unit, or add the unit first", show: true });
            return;
        }
        let createdValues = {
            'user': selectedUser.id,
            'unit_id': String(selectedUnitItem.id),
            'firstName': selectedFirstName,
            'lastName': selectedLastName,
            'email': selectedEmail,
            'client': selectedUser.client,
            'building': "0",
            'role': selectedRole ? selectedRole.id.toString() : ""
        }
        console.log(createdValues);
        if (selectedBuildingItem.id !== undefined && selectedBuildingItem.id !== null) {
            createdValues["building"] = selectedBuildingItem.id.toString()
        }
        setActiveLoading(true);
        UserService.updateUser(selectedUser.id, createdValues)
            .then((e) => {

                setActiveLoading(false);
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "info", error_message: "" })
                window.location.reload(true);
            }).catch((err) => {
                setActiveLoading(false);
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "error", error_message: err.response.data.status })

            });

    }



    const onClickResendEmailItem = (elem) => {
        let id = elem.target.id;
        setActiveLoading(true);
        UserService.resendConfirmEmail(id)
            .then((e) => {
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "info", error_message: "" })
                // window.location.reload(true);
                setActiveLoading(false);
                setDialogSetting({ ...dialogSetting, show: false });
            }).catch((err) => {
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "error", error_message: err.response.data.status });
                setActiveLoading(false);
                setDialogSetting({ ...dialogSetting, show: false });
            });
    }
    const onClickDisableItem = (elem) => {
        let id = elem.target.id;
        setActiveLoading(true);
        UserService.disableUser(id)
            .then((e) => {
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "info", error_message: "" })
                // window.location.reload(true);
                setActiveLoading(false);
                setDialogSetting({ ...dialogSetting, show: false });
                window.location.reload(true);
            }).catch((err) => {
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "error", error_message: err.response.data.status });
                setActiveLoading(false);
                setDialogSetting({ ...dialogSetting, show: false });
            });
    }
    const onClickRemoveItem = (elem) => {
        let id = elem.target.id;
        setActiveLoading(true);
        UserService.deleteUser(id)
            .then((e) => {
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "info", error_message: "" })

                setActiveLoading(false);
                setDialogSetting({ ...dialogSetting, show: false });
                window.location.reload(true);
            }).catch((err) => {
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "error", error_message: err.response.data.status });
                setActiveLoading(false);
                setDialogSetting({ ...dialogSetting, show: false });
            });
    }

    const [dialogSetting, setDialogSetting] = useState({ show: false, onClickDone: onClickRemoveItem, id: "" });


    const onClickRow = (elem) => {
        let actionToDo = elem.target.getAttribute("action");
        let rowName = elem.target.getAttribute("rowname");
        let client = elem.target.getAttribute("client");
        let rowId = elem.target.id;
        setSelectedUser({ ...selectedUser, id: rowId, name: rowName, client: client });
        console.log(actionToDo + rowName + rowId)
        switch (actionToDo) {
            case "change_password":
                setShowModalChangePassword(true);
                break;
            case "edit":
                setShowModalChangeUnit(true);
                setActiveLoading(true);
                getUserData(rowId);
                break;
            case "show_info":
                setShowModalUserInfo(true);
                getUserData(rowId);
                break;
            case "book_amenity":
                // const navigate = useNavigate();
                window.location.href = "/amenities?userid=" + rowId
                break;
            case "delete":
                setDialogSetting({ ...dialogSetting, title: "Delete", show: true, id: rowId, onClickDone: onClickRemoveItem })
                break;
            case "disable":
                setDialogSetting({ ...dialogSetting, title: "Disable/Enable", show: true, id: rowId, onClickDone: onClickDisableItem })
                break;
            case "resend_confirm":
                setDialogSetting({ ...dialogSetting, title: "Resend Confirmation Email", show: true, id: rowId, onClickDone: onClickResendEmailItem })
                break;
        }
    }
    const onClickNew = (e) => {
        const defaultRole = { id: 3, label: "Member" };

        setSelectedRole(defaultRole); //

        setUserInsertSetting({
            ...userInsertSetting,
            show: true,
            type: "user"
        });
    }

    const selectedRecipientCount = Object.keys(selectedRecipients).length;
    const selectedRecipientEmails = Object.values(selectedRecipients)
        .map(({ email }) => email)
        .filter(Boolean);
    const selectedRecipientPreview = selectedRecipientEmails.length > 3
        ? `${selectedRecipientEmails.slice(0, 3).join(", ")} ...`
        : selectedRecipientEmails.join(", ");
    const selectedRecipientTooltip = selectedRecipientEmails.join("\n");
    const toggleRecipient = (recipient) => {
        setSelectedRecipients((current) => {
            const next = { ...current };
            if (next[recipient.id]) {
                delete next[recipient.id];
            } else {
                next[recipient.id] = recipient;
            }
            return next;
        });
    };
    const sendBulkEmail = () => {
        const textBody = bulkEmailBody.replace(/<[^>]+>/g, "").replace(/&nbsp;/g, " ").trim();
        if (selectedRecipientCount === 0 || !bulkEmailSubject.trim() || !textBody) {
            setSnackBarSetting({ ...snackBarSetting, show: true, type: "error", error_message: "Please select users and enter subject and body." });
            return;
        }
        setActiveLoading(true);
        UserService.sendBulkEmail(Object.keys(selectedRecipients).map((id) => Number(id)), bulkEmailSubject.trim(), bulkEmailBody)
            .then(() => {
                setActiveLoading(false);
                setSelectedRecipients({});
                setBulkEmailSubject("");
                setBulkEmailBody("");
                setShowBulkEmailModal(false);
                setSnackBarSetting({ ...snackBarSetting, show: true, type: "info", error_message: "" });
            })
            .catch((err) => {
                setActiveLoading(false);
                setSnackBarSetting({
                    ...snackBarSetting,
                    show: true,
                    type: "error",
                    error_message: err.response?.data?.status || "Email could not be sent",
                });
            });
    };
    const renderBulkEmailButton = () => {
        if (selectedRecipientCount === 0) return null;

        return (
            <MDButton
                variant="gradient"
                color="info"
                size="small"
                onClick={() => setShowBulkEmailModal(true)}
            >
                Email Selected ({selectedRecipientCount})
            </MDButton>
        );
    };


    const [tableSetting, setTableSetting] = useState({
        data: DataTableDataUsers,
        progressChanger: setActiveLoading,
        showButton: true,
        buttonText: title,
        buttonClick: onClickNew,
        onClickRow: onClickRow
    });

    const renderUserInfoModal = () => {
        return <Modal open={showModalUserInfo} color={"warning"}
            onClose={(e) => { setShowModalUserInfo(false) }}>
            <MDBox sx={modalStyle}>
                <Card id="basic-info" sx={{ overflow: "visible" }}>
                    <MDBox p={3} pb={2}>
                        <MDTypography variant="h6">User Info ({selectedUser.name})</MDTypography>
                    </MDBox>
                    <MDBox component="form" pb={3}  >
                        <Grid container justifyContent={"center"} >
                            <Grid container spacing={2} pt={2} px={2} xs={12} md={12}   >

                                <Grid item xs={12} md={12}>
                                    <MDAvatar src={CoreService.BASE_API_URL + selectedImage} bgColor={"dark"} size={"xxl"} shadow={"md"} />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <MDTypography fontWeight={"bold"} textTransform={"capitalize"}   >
                                        <LabelImportant color={"warning"} />
                                        {selectedFirstName} {selectedLastName}</MDTypography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <MDTypography fontWeight={"bold"} textTransform={"capitalize"}   >
                                        <LabelImportant color={"warning"} />
                                        {selectedUnit}</MDTypography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <MDTypography fontWeight={"bold"} textTransform={"capitalize"}   >
                                        <LabelImportant color={"warning"} />
                                        {selectedBuilding}</MDTypography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <MDTypography fontWeight={"bold"} textTransform={"capitalize"}   >
                                        <LabelImportant color={"warning"} />
                                        {selectedClient}</MDTypography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <MDTypography fontWeight={"bold"} textTransform={"capitalize"}   >
                                        <LabelImportant color={"warning"} />
                                        {selectedPostalCode}</MDTypography>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <MDTypography fontWeight={"bold"} textTransform={"capitalize"}   >
                                        <LabelImportant color={"warning"} />
                                        {selectedPhone}</MDTypography>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <MDTypography fontWeight={"bold"} textTransform={"capitalize"}   >
                                        <LabelImportant color={"warning"} />
                                        {selectedAddress}</MDTypography>
                                </Grid>


                            </Grid>
                        </Grid>
                    </MDBox>
                </Card>
            </MDBox>
        </Modal>
    }

    const renderChangePasswordModel = () => {
        return <Modal open={showModalChangePassword} color={"warning"}
            onClose={(e) => { setShowModalChangePassword(false) }}>
            <MDBox sx={modalStyle}>
                <Card id="basic-info" sx={{ overflow: "visible" }}>
                    <MDBox p={3} pb={2}>
                        <MDTypography variant="h6">Change Password ({selectedUser.name})</MDTypography>
                    </MDBox>
                    <MDBox component="form" pb={3} >
                        <Grid container >
                            <Grid container spacing={2} pt={2} px={2} xs={12} md={12}   >
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        required fullWidth
                                        type="password" label="New Password" name="newPassword"
                                        error={!!errors.newPassword}
                                        helperText={errors.newPassword?.message}
                                        value={values.newPassword}
                                        {...register("newPassword")}
                                        onChange={(event) =>
                                            handleChange({ ...values, newPassword: event.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <TextField
                                        required fullWidth
                                        type="password" label="Confirm Password" name="passwordConfirmation"
                                        error={!!errors.passwordConfirmation}
                                        helperText={errors.passwordConfirmation?.message}
                                        value={values.passwordConfirmation}
                                        {...register("passwordConfirmation")}
                                        onChange={(event) =>
                                            handleChange({ ...values, passwordConfirmation: event.target.value })}
                                    />
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <MDButton color={"info"} size={"large"} sx={{ width: '50%' }}
                                        disabled={!isValid} onClick={onClickSaveData}  >Save Data</MDButton>
                                </Grid>

                            </Grid>
                        </Grid>
                    </MDBox>
                </Card>
            </MDBox>
        </Modal>
    }

    const [buildingList, setBuildingList] = useState([]);

    const loadBuildings = () => {
        clientsService.getBuildings()
            .then((res) => {
                let data = []
                res.data.forEach((k) => {
                    data.push({ "building_name": k.name, "id": k.id })
                })
                // console.log(data);
                setBuildingList(data);
                // setSelectedBuildingItem(data[0]);
            })
            .catch((e) => {
                console.log(e.toString());
            });
    }




    const [selectedUnit, setSelectedUnit] = useState("")
    const [selectedUnitItem, setSelectedUnitItem] = useState(null)
    const [unitSearch, setUnitSearch] = useState("")
    const [showAddUnit, setShowAddUnit] = useState(false)
    const [newUnitNumber, setNewUnitNumber] = useState("")
    const [buildingUnits, setBuildingUnits] = useState([])
    const [unitsLoading, setUnitsLoading] = useState(false)
    const [selectedFirstName, setSelectedFirstName] = useState("")
    const [selectedLastName, setSelectedLastName] = useState("")
    const [selectedImage, setSelectedImage] = useState("")
    const [selectedEmail, setSelectedEmail] = useState("")
    const [selectedBuilding, setSelectedBuilding] = useState("")
    const [selectedBuildingItem, setSelectedBuildingItem] = useState({})
    const [selectedClient, setSelectedClient] = useState("")
    const [selectedAddress, setSelectedAddress] = useState("")
    const [selectedPostalCode, setSelectedPostalCode] = useState("")
    const [selectedPhone, setSelectedPhone] = useState("")
    const [selectedRole, setSelectedRole] = useState(null)

    useEffect(() => {
        loadBuildings();
    }, []);

    useEffect(() => {
        if (buildingList.length && selectedBuilding) {
            const found = buildingList.find(
                (b) => b.building_name === selectedBuilding
            );
            if (found) setSelectedBuildingItem(found);
        }
    }, [buildingList, selectedBuilding]);

    useEffect(() => {
        const buildingId = selectedBuildingItem?.id;
        setBuildingUnits([]);
        if (!showModalChangeUnit || !buildingId) return;

        let active = true;
        setUnitsLoading(true);
        clientsService.getBuildingUnits(buildingId)
            .then((res) => {
                if (active) {
                    const units = Array.isArray(res.data) ? [...res.data] : [];
                    units.sort((a, b) => String(a.unit || "").localeCompare(String(b.unit || ""), undefined, { numeric: true, sensitivity: "base" }));
                    setBuildingUnits(units);
                }
            })
            .catch((err) => {
                if (active) {
                    setSnackBarSetting({ type: "error", error_message: err.response?.data?.status || "Could not load units", show: true });
                }
            })
            .finally(() => {
                if (active) setUnitsLoading(false);
            });

        return () => { active = false; };
    }, [showModalChangeUnit, selectedBuildingItem?.id]);

    const userRole = getUserRole();
    const isUserPage = userInsertSetting.type === "user";
    const roleOptions = (() => {
        const all = [
            { id: 2, label: "Admin" },
            { id: 4, label: "Staff" },
            { id: 3, label: "Member" },
        ];

        if (isUserPage) {
            return all.filter(r => r.id === 3); 
        }

        if (userRole === "super_admin") return all;
        if (userRole === "admin") return all.filter(r => r.id === 4 || r.id === 3);
        if (userRole === "staff") return all.filter(r => r.id === 3);

        return [];
    })();


    const getUserData = (userId) => {
        UserService.getUser(userId)
            .then((result) => {

                setActiveLoading(false);
                console.log(result.data);
                setSelectedFirstName(result.data["first_name"]);
                setSelectedLastName(result.data["last_name"]);
                setSelectedEmail(result.data["email"]);
                setSelectedImage(result.data["image"]);
                setSelectedBuilding(result.data["building"]);
                // setSelectedBuildingItem(
                //     {
                //         "building_name":result.data["building_item"]["building_name"],
                //         "id":result.data["building_item"]["id"]
                //     });
                // setSelectedBuildingItem(result.data["building_item"]);
                setSelectedBuildingItem({
                    building_name: result.data["building_item"]?.["building_name"] || "",
                    id: result.data["building_item"]?.["id"]
                });
                setSelectedClient(result.data["client"]);
                setSelectedUnit(result.data["unit"] || "");
                const unitItem = result.data["unit_item"];
                setSelectedUnitItem(unitItem?.id ? unitItem : null);
                setUnitSearch(unitLabel(unitItem));
                setSelectedAddress(result.data["address"]);
                setSelectedPostalCode(result.data["postal_code"]);
                setSelectedPhone(result.data["phone"]);
                const roleId = result.data["role"];
                const foundRole = roleOptions.find(r => r.id === roleId);
                setSelectedRole(foundRole || null);
            }).catch((reason) => {
                setActiveLoading(false);
                alert(reason);

                setSelectedUnit("");
                setSelectedFirstName("");
                setSelectedLastName("");
                setSelectedImage("");
                setSelectedBuilding("");
                setSelectedClient("");
            });
    }


    const renderChangeUnits = () => {
        return <Modal open={showModalChangeUnit} color={"warning"}
            onClose={(e) => { setShowModalChangeUnit(false) }}>
            <MDBox sx={modalStyle}>
                <LoadingOverlay active={activeLoading} spinner text='Loading...'>
                    <Card id="basic-info" sx={{ overflow: "visible" }}>
                        <MDBox p={3} pb={2}>
                            <MDTypography variant="h6">Edit User ({selectedUser.name})</MDTypography>
                        </MDBox>
                        <MDBox component="form" pb={3} >
                            <Grid container >
                                <Grid container spacing={2} pt={2} px={2} xs={12} md={12}   >
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            required fullWidth
                                            value={selectedFirstName}
                                            type="text" label="First Name" name="firstName"
                                            onChange={(event) =>
                                                setSelectedFirstName(event.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            required fullWidth
                                            value={selectedLastName}
                                            type="text" label="Last Name" name="lastName"
                                            onChange={(event) =>
                                                setSelectedLastName(event.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <TextField
                                            fullWidth
                                            value={selectedEmail}
                                            type="text" label="Email" name="email"
                                            onChange={(event) =>
                                                setSelectedEmail(event.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <Autocomplete
                                            value={selectedBuildingItem || null}
                                            options={buildingList}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            getOptionLabel={(option) => option.building_name || ""}
                                            onChange={(e, v) => {
                                                setSelectedBuildingItem(v || {});
                                                setSelectedUnit("");
                                                setSelectedUnitItem(null);
                                                setUnitSearch("");
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Building" InputLabelProps={{ shrink: true }} />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <Autocomplete
                                            autoHighlight
                                            options={buildingUnits}
                                            loading={unitsLoading}
                                            disabled={!selectedBuildingItem?.id}
                                            value={selectedUnitItem}
                                            inputValue={unitSearch}
                                            filterOptions={filterUnitOptions}
                                            getOptionLabel={unitLabel}
                                            isOptionEqualToValue={(option, value) => option.id === value?.id}
                                            onChange={(e, value) => {
                                                if (value?.newUnitNumber) {
                                                    setNewUnitNumber(value.newUnitNumber);
                                                    setShowAddUnit(true);
                                                } else {
                                                    setSelectedUnitItem(value);
                                                    setSelectedUnit(value?.unit || "");
                                                    setUnitSearch(unitLabel(value));
                                                }
                                            }}
                                            onInputChange={(e, value, reason) => {
                                                if (reason === "input") {
                                                    setUnitSearch(value);
                                                    setSelectedUnitItem(null);
                                                }
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    fullWidth
                                                    label="Unit Name"
                                                    placeholder="Search or type a unit number"
                                                    helperText="Choose a unit, or select Add unit to enter its floor and section."
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <Autocomplete
                                            value={selectedRole}
                                            options={roleOptions}
                                            getOptionLabel={(option) => option.label || ""}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            onChange={(e, v) => {
                                                setSelectedRole(v)
                                            }}
                                            renderInput={(params) => (
                                                <TextField {...params} label="Role" InputLabelProps={{ shrink: true }} />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={12}>
                                        <MDButton color={"info"} size={"large"} sx={{ width: '50%' }}
                                            onClick={onClickSaveDataUnits} >Save Data</MDButton>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </MDBox>
                    </Card>
                </LoadingOverlay>
                <UnitCreateModal open={showAddUnit}
                    building={selectedBuildingItem}
                    initialNumber={newUnitNumber}
                    onClose={() => setShowAddUnit(false)}
                    onCreated={(unit) => {
                        const option = { id: unit.id, unit: unit.unit, floor: unit.floor, section: unit.section };
                        setBuildingUnits((current) => [...current, option]);
                        setSelectedUnitItem(option);
                        setSelectedUnit(option.unit);
                        setUnitSearch(unitLabel(option));
                        setShowAddUnit(false);
                    }} />
            </MDBox>
        </Modal>
    }

    const renderBulkEmailModal = () => {
        return <Modal open={showBulkEmailModal} color={"warning"}
            onClose={() => { setShowBulkEmailModal(false) }}>
            <MDBox sx={{ ...modalStyle, width: "720px", maxWidth: "95vw" }}>
                <Card id="bulk-email" sx={{ overflow: "visible" }}>
                    <MDBox p={3} pb={2}>
                        <MDTypography variant="h6">Send Email To Selected Users ({selectedRecipientCount})</MDTypography>
                        {selectedRecipientEmails.length > 0 && (
                            <Tooltip
                                placement="bottom-start"
                                title={<span style={{ whiteSpace: "pre-line" }}>{selectedRecipientTooltip}</span>}
                            >
                                <MDTypography variant="caption" color="text" sx={{ cursor: "default" }}>
                                    {selectedRecipientPreview}
                                </MDTypography>
                            </Tooltip>
                        )}
                    </MDBox>
                    <MDBox pb={3} px={3}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    required
                                    label="Subject"
                                    value={bulkEmailSubject}
                                    onChange={(event) => setBulkEmailSubject(event.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <MDBox sx={{
                                    "& .ql-container": { minHeight: "260px" },
                                    "& .ql-editor": { minHeight: "260px" },
                                }}>
                                    <MDEditor
                                        value={bulkEmailBody}
                                        onChange={setBulkEmailBody}
                                        modules={{
                                            toolbar: [
                                                ["bold", "italic", "underline"],
                                                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                                [{ list: "bullet" }, { list: "ordered" }],
                                                ["blockquote"],
                                                [{ align: [] }],
                                                ["clean"],
                                            ],
                                        }}
                                    />
                                </MDBox>
                            </Grid>
                            <Grid item xs={12}>
                                <MDButton color="info" size="large" onClick={sendBulkEmail}>Send Email</MDButton>
                            </Grid>
                        </Grid>
                    </MDBox>
                </Card>
            </MDBox>
        </Modal>
    };



    const renderUserList = () => {
        // console.log('renderUserList')
        return (
            <MDBox my={3}>
                {renderChangePasswordModel()}
                {renderChangeUnits()}
                {renderUserInfoModal()}
                {renderBulkEmailModal()}
                <SnackShower values={snackBarSetting} setValues={setSnackBarSetting} />
                <DialogShower values={dialogSetting} setValues={setDialogSetting} />
                <TableShower
                    values={{
                        ...tableSetting,
                        toolbarActions: renderBulkEmailButton(),
                        bulkEmail: {
                            selectedRecipients,
                            onToggleRecipient: toggleRecipient,
                        },
                    }}
                    setValues={setTableSetting}
                />
                {/*{renderTable()}*/}
                <InsertUserComponent settings={userInsertSetting} setSettings={setUserInsertSetting}
                    snackBarSetting={snackBarSetting} setSnackBarSetting={setSnackBarSetting} />
            </MDBox>
        )
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <LoadingOverlay active={activeLoading} spinner text='Loading...'>
                {renderUserList()}
            </LoadingOverlay>
            <Footer />
        </DashboardLayout>
    );
}

export default Users;
